export const encode = (str: string): string => {
  return btoa(unescape(encodeURIComponent(str)));
};

export const decode = (str: string): string => {
  return decodeURIComponent(escape(atob(str)));
};
